import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

interface DividerProps {
  style?: StyleProp<ViewStyle>;
}

export const Divider: React.FC<DividerProps> = ({ style }) => {
  const [styles] = useStyles();

  return <View style={[styles.base, style]} />;
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.sk.color.divider.default,
    height: 1,
  },
}));
